import Axios from 'axios';
import { downloadFile } from 'common/fileDownload';

export interface ExportEpdItem {
	itemCode: string;
	quantity: number;
}

export const downloadClimateReport = async (
	apiUrl: string,
	items: ExportEpdItem[]
) => {
	const response = await Axios.post(apiUrl, items, {
		responseType: 'blob',
	});
	if (response?.data) {
		downloadFile(
			response.data,
			response.headers?.['content-disposition'],
			'Climate_report'
		);
	}
};
